import styled from "styled-components";
import { Checkbox } from "antd";

export const DisplayFlex = styled.div`
  display: flex;
`;

export const CustomCheckbox = styled(Checkbox)`
  .ant-checkbox-checked::after {
    border: none;
  }
  span{
    font-family: ${props => props.theme.fontFamily.helveticaNeue};
    font-size: ${props => props.theme.fontSize.primary};
    line-height: ${props => props.theme.lineHeight.primary};
    color: ${props => props.theme.fontColors.textColor};
    @media(max-width: 576px){
      font-size: ${props => props.theme.fontSize.secondary};
      line-height: ${props => props.theme.lineHeight.secondary};
    }
  }
  .ant-checkbox {
    .ant-checkbox-inner {
      height: 18px;
      width: 18px;
      border-radius: 0;
      border-width: 1.5px;
      border-color: ${props => props.theme.border.unchecked};
      background-color: ${props => props.theme.backgroundColor.layoutLight};
      &::after {
        border-color: ${props => props.theme.colors.primaryColor};
        left: 27%;
        height: 7px;
        width: 4px;
      }
    }
    &.ant-checkbox-checked {
      .ant-checkbox-inner {
        border-color: ${props => props.theme.colors.primaryColor};
      }
    }
  }
`;

export const BoxDetailWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  box-sizing: border-box;
  padding-top: 20px;
  padding-bottom: 20px;
  ${({ fullwidth }) => (fullwidth ? `width:100%;!important` : `width:auto;`)}
  ${({ halfwidth }) => (halfwidth ? `width:50%;` : `width:auto;`)}
  ${({ noBorder }) =>
    noBorder === 2 ? `border-bottom:none;` : `border-bottom:1px solid #bfbfbf;`}
  @media only screen and (max-width:576px){
    max-width:100%;
  }
`;

export const PreviewLetterWrapper = styled.div`
  #myMm {
    height: "1mm";
  }
`;

export const PreviewLetterLogo = styled.div`
  width: 30px;
  height: 30px;
  border: 1px solid ${props => props.theme.border.filledTabsInactive};
  margin: 0px 10px;
`;

export const PreviewLetterContent = styled.div`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  ${({ postlink }) => (postlink ? `margin-left:4px;` : `margin-left:0px`)};
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: ${props => props.theme.fontSize.secondary};
  }
`;

export const PreviewFlex = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const LetterWrapper = styled.div`
  border-top: 1px solid ${props => props.theme.backgroundColor.tableAltRowDark};
  border-bottom: 1px solid
    ${props => props.theme.backgroundColor.tableAltRowDark};
  border-right: 1px solid
    ${props => props.theme.backgroundColor.tableAltRowDark};
  border-left: 5px solid ${props => props.theme.backgroundColor.primaryColor};
  align-items: center;
  padding: 25px 0 25px 20px;
  &:hover {
    background-color: ${props => props.theme.backgroundColor.tableAltRowDark};
  }
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    border-left: 1px solid
      ${props => props.theme.backgroundColor.tableAltRowDark};
    border-top: 6px solid ${props => props.theme.backgroundColor.primaryColor};
  }
`;

export const Disclaimer = styled.div`
  font-family: ${props => props.theme.fontFamily.berkeleyStdMedium};
  font-size: ${props => props.theme.fontSize.h4};
  color: ${props => props.theme.fontColors.headingColor};
  padding-bottom: 14px;
  margin-top: ${props => props.marginTop};
`;

export const DisclaimerContent = styled.div`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  line-height: ${props => props.theme.lineHeight.primary};
  letter-spacing: 0;
  color: ${props => props.theme.fontColors.textColor};
  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    width: 63vw;
  }
`;

export const DisplayFlexDis = styled.div`
  display: flex;
  .ant-checkbox-wrapper {
    display: flex;
    padding-right: 0px;
  }
  .ant-form-item label {
    font-family: ${props => props.theme.fontFamily.helveticaNeue};
    font-size: ${props => props.theme.fontSize.primary};
    line-height: ${props => props.theme.lineHeight.primary};
    font-weight: normal;
    color: ${props => props.theme.fontColors.thead};
  }
  .ant-checkbox {
    top: 7px;
  }
  .ant-form-item {
    margin: 0;
  }
`;

export const SmallDetails = styled.div`
font-family: ${props => props.theme.fontFamily.helveticaNeue};
font-size: ${props => props.theme.fontSize.primary};
${({ pad }) => (pad ? `margin-top:20px;padding-bottom:0px;` : ``)}
${({ padLeft }) => padLeft && `margin-left:6px;`}
${({ pad20 }) => (pad20 ? `padding-top:20px;` : `padding-top:0px;`)}
${({ padTop }) => (padTop ? `padding-top:10px;` : `padding-top:0px;`)}
${({ borderBottom }) =>
  borderBottom ? `border-bottom:1px solid #bfbfbf;` : `border: none;`}
`;
